module.exports = __webpack_public_path__ + "static/media/en-cancel-service_6.27c05d6b.png";